/* eslint-disable no-useless-concat */
import api from "./api";
import {  Dato, Dato_Operario, CupoAsignado, Datos, DetalleCortesOperarios, cupoRestante, cupoHora, DisponibilidadBeneficios} from "src/utils";

const Asignacion = {
  async AsignacionAPI() {
    const registros: Dato[] = [];

    await api.get(`asignacion/puntos_operarios_asignados`).then(
      (response) => {
        const asignacion = response.data.datos;
        asignacion.forEach((registro: Dato) => {
          registros.push({
            ps_nombre: registro.ps_nombre,
            ps_codigo: registro.ps_codigo,
            ps_id: registro.ps_id,
            cantidad: registro.cantidad,
          });
        });
      },
      (error) => error
    );

    return registros;
  },

   async DatellesGeneralesAsignacion() {
    const detalles: CupoAsignado[] = [];
    const detallesCupo: cupoHora[] = [];
    const detallesResto: cupoRestante[] = [];

    await api.get(`/punto_servicio/cupo_horas/`+sessionStorage['ps_id']).then(
      (response) => {
        const cupos = response.data.datos
        cupos.forEach(() => {
        detalles.push({
          DOMIN: cupos[0]['cupo_asignado']['DOMIN'],
          DONOC: cupos[0]['cupo_asignado']['DONOC'],
          HNOC: cupos[0]['cupo_asignado']['HNOC'],
          NORMA: cupos[0]['cupo_asignado']['NORMA'],
          total: cupos[0]['cupo_asignado']['total'],
        });
        /////
        detallesCupo.push({
          DOMIN: cupos[0]['cupo_hora']['DOMIN'],
          DONOC: cupos[0]['cupo_hora']['DONOC'],
          FENOC: cupos[0]['cupo_hora']['FENOC'],
          FERIA: cupos[0]['cupo_hora']['FERIA'],
          HNOC: cupos[0]['cupo_hora']['HNOC'],
          HNOCM: cupos[0]['cupo_hora']['HNOCM'],
          NORMA: cupos[0]['cupo_hora']['NORMA'],
          total: cupos[0]['cupo_hora']['total']
        });
          ////
          detallesResto.push({
          DOMIN: cupos[0]['cupo_restante']['DOMIN'],
          DONOC: cupos[0]['cupo_restante']['DONOC'],
          FENOC: cupos[0]['cupo_restante']['FENOC'],
          FERIA: cupos[0]['cupo_restante']['FERIA'],
          HNOC: cupos[0]['cupo_restante']['HNOC'],
          HNOCM: cupos[0]['cupo_restante']['HNOCM'],
          NORMA: cupos[0]['cupo_restante']['NORMA'],
          total: cupos[0]['cupo_restante']['total']
        });

      });

      },
      (error) => error
    );
    
    return [detalles,detallesCupo,detallesResto]
  },



  async DatelleOperarioAsignacion() {
    const detalleOperarioAsignable: Datos[] = [];

    await api.get(`/asignacion/operarios_asignados/`+sessionStorage['ps_id']).then(
      (response) => {
        const asignacion = response.data.datos;
        asignacion.forEach((registro: Datos) => {
          detalleOperarioAsignable.push({
            id: registro.id,
            legajo: registro.legajo,
            operario: registro.operario,
            total_asignado: registro.total_asignado
          });
        });
      },
      (error) => error
    );

    return detalleOperarioAsignable;
  },

  async corteAsignacionOperario() {
    const detallesCorte: DetalleCortesOperarios[] = [];

    await api.get(`asignacion/asignaciones_detalle/`+sessionStorage['ps_id']+`?op_id=${sessionStorage['opId']}`).then(
      (response) => {
        const detalleCorte = response.data.datos
        detalleCorte.forEach((registro:DetalleCortesOperarios ) => { 
        detallesCorte.push({
          dom_ent:     registro.dom_ent,
          dom_sal:     registro.dom_sal,
          fecha_inicio:registro.fecha_inicio,
          id:          registro.id,
          jue_ent:     registro.jue_ent,
          jue_sal:     registro.jue_sal,
          lun_ent:     registro.lun_ent,
          lun_sal:     registro.lun_sal,
          mar_ent:     registro.mar_ent,
          mar_sal:     registro.mar_sal,
          mie_ent:     registro.mie_ent,
          mie_sal:     registro.mie_sal,
          sab_ent:     registro.sab_ent,
          sab_sal:     registro.sab_sal,
          total_horas: registro.total_horas,
          vie_ent:     registro.vie_ent,
          vie_sal:     registro.vie_sal
        });
      });
        
      },
      (error) => error
    );

    return detallesCorte;
  },

  
async listarOperarios(){
  const registro_Operario: Dato_Operario[] = [];

    await api.get(`/usuario/operarios`).then(
      (response) => {
        const operarios = response.data.datos;
        operarios.forEach((registro: Dato_Operario) => {
          registro_Operario.push({
            cargo: registro.cargo,
            legajo: registro.legajo,
            nombre: registro.nombre
          });
        });
      },
      (error) => error
    );

    return registro_Operario;
  },
  
async buscarOperarios(filtros){
  // filtros: { ps_id, fecha_inicio, fecha_fin, perfil, genero, supervisor,
  //            total_horas, lun_ent, lun_sal, ... dom_ent, dom_sal }
  const params = new URLSearchParams();
  Object.keys(filtros || {}).forEach((k) => {
    const v = filtros[k];
    if (v !== undefined && v !== null && v !== '') {
      params.append(k, v);
    }
  });

  try {
    const response = await api.get(`asignacion/buscar-operarios?${params.toString()}`);
    if (response && response.status === 200 && response.data && response.data.datos) {
      return response.data.datos;
    }
    return [];
  } catch (error) {
    return [];
  }
},

async borrarCorte(id,fecha_fin){
  return api.post(`asignacion/cerrar_asignaciones?asig_id=${id}&fecha_fin=${fecha_fin}`);
},

async guardarAsignacion(datos){
  return api.post(`asignacion/guardar-asignacion`,datos);
},

async obtenerDisponibilidadBeneficios(ps_id): Promise<DisponibilidadBeneficios | null> {
  try {
    const response = await api.get(`asignacion/disponibilidad-beneficios/${ps_id}`);
    if (response && response.status === 200 && response.data && response.data.datos) {
      return response.data.datos as DisponibilidadBeneficios;
    }
    return null;
  } catch (error) {
    return null;
  }
},



}

export default Asignacion;
